import {
  composeClassNames,
  ifDefined,
  universalEach,
  withDefault,
} from "@faedev/editor-utils";
import { CSSProperties, ReactNode } from "react";
import { CardDeck } from "react-bootstrap";
import Heading from "src/components/Heading";
import Paragraph from "src/components/Paragraph";
import Translate from "src/components/Translate";
import VideoCard from "src/components/VideoCard";
import validateContent from "src/functions/validateContent";
import { sGroupTitle } from "src/styles/sGroupTitle.module.scss";
import { sVideoList } from "src/styles/sVideoList.module.scss";
import { ApiVideoCard } from "src/types/ApiVideoCard";
import { VariantSize } from "src/types/VariantSize";
import { VariantVideoPreview } from "src/types/VariantVideoPreview";
import MerchCard from "./MerchCard";
import NftCard from "./NftCard";

type Props = {
  size: VariantSize;
  title?: ReactNode | null | undefined;
  description?: ReactNode | null | undefined;
  data: ApiVideoCard[];
  type: VariantVideoPreview;
  style?: CSSProperties | null | undefined;
  className?: (string | string) | null | undefined;
  showPrivate?: boolean | null | undefined;
  merch?: boolean;
  kind?: "video" | "merch" | "nft";
};

function VideoList({
  size,
  title,
  description,
  data,
  type,
  style,
  className,
  showPrivate,
  kind = "video",
}: Props) {
  return data.length > 0 ? (
    <div
      style={style}
      className={composeClassNames([
        sVideoList,
        className,
        "video-list-wrapper",
      ])}
    >
      {title ? (
        <Heading
          type="h2"
          title={title}
          className={composeClassNames([sGroupTitle, "video-list-title"])}
        />
      ) : null}
      {description ? (
        <Paragraph
          size="md"
          className={composeClassNames(["video-list-description"])}
        >
          {description}
        </Paragraph>
      ) : null}
      <CardDeck className={composeClassNames([size, "video-list"])}>
        {data.length === 0 ? <Translate tKey={"No videos found"} /> : null}
        {(() => {
          let validated = false;
          let count = 0;
          let sortData = data.sort((a, b) =>
            a.order > b.order ? 1 : b.order > a.order ? -1 : 0
          );
          return universalEach(sortData, (item, i) => {
            validated = validateContent(
              withDefault(item.blocked, true),
              ifDefined(
                item.verified,
                (value) => value.verified,
                () => false
              ),
              showPrivate ? false : withDefault(item.private, false)
            );
            validated && count++;
            return validated ? (
              <div key={i}>
                {kind === "video" && (
                  <VideoCard
                    data={item}
                    type={withDefault(type, `preview`)}
                    size={size}
                    bunch={data.length}
                    serialNo={count}
                    key={`video-card-` + String(count)}
                  />
                )}
                {kind === "merch" && (
                  <MerchCard
                    data={item}
                    type={withDefault(type, `preview`)}
                    size={size}
                    key={`video-card-` + String(count)}
                  />
                )}
                {kind === "nft" && (
                  <NftCard
                    data={item}
                    type={withDefault(type, `preview`)}
                    size={size}
                    key={`video-card-` + String(count)}
                  />
                )}
              </div>
            ) : null;
          });
        })()}
      </CardDeck>
    </div>
  ) : null;
}

export default VideoList;
